module.exports = __webpack_public_path__ + "img/slide1.0833b0e2.png";